import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Container, Row, Col } from "reactstrap";
import LeftSideContent from "./LeftSideContent";
import RightSideContent from "./RightSideContent";
// import Section from "./Section";

const BackToCandidatesButton = ({ backUrl }) => {
  if (!backUrl) return null;
  return (
    <Link to={backUrl}>
      <Button color="secondary" outline className="d-inline-flex align-items-center gap-2">
        <i className="mdi mdi-arrow-left"></i>
        Volver a candidatos postulados
      </Button>
    </Link>
  );
};

const CandidateDetails = () => {
  document.title = "Avaza Empleos | Detalles del candidato";
  const location = useLocation();
  const returnJobOfferId = location.state?.returnJobOfferId;
  const returnPage = location.state?.returnPage ?? 1;
  const returnPageSize = location.state?.returnPageSize;
  const backUrl = returnJobOfferId
    ? `/listcandidateapply?jobOfferId=${returnJobOfferId}&page=${returnPage}${returnPageSize ? `&pageSize=${returnPageSize}` : ""}`
    : null;

  return (
    <React.Fragment>
      {/* <Section /> */}
      <section className="section">
        <Container>
          <Row className="mb-3">
            <Col>
              <BackToCandidatesButton backUrl={backUrl} />
            </Col>
          </Row>
          <Row>
            <LeftSideContent />
            <RightSideContent />
          </Row>
          <Row className="mt-4">
            <Col>
              <BackToCandidatesButton backUrl={backUrl} />
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default CandidateDetails;
